import LogoSpinner from '@/components/atoms/LogoSpinner';
import { TInfinitePagination } from '@/services/api';
import { Center, Text, VStack } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

interface ITablePaginationProps {
  infinitePagination: TInfinitePagination;
  totalItemsLabel?: string;
}

const InfiniteTablePagination = ({ infinitePagination, totalItemsLabel = 'Total Items:' }: ITablePaginationProps) => {
  const { ref: inViewRef, inView } = useInView({
    threshold: 0.5,
    trackVisibility: true,
    skip: false,
    delay: 100,
  });

  useEffect(() => {
    if (inView && infinitePagination.hasNextPage) {
      infinitePagination.fetchNextPage();
    }
  }, [inView]);

  return (
    <VStack
      style={{ justifyContent: 'space-between', alignItems: 'start', marginTop: '20px', width: '100%' }}
      position={'relative'}
    >
      <Text marginLeft={'20px'} fontWeight={'bold'}>
        {totalItemsLabel} {infinitePagination.totalItems}
      </Text>

      {/* Loading element at the bottom */}
      <Center ref={inViewRef} height={'30px'} width={'100px'}></Center>

      <Center pos={'absolute'} width={'100%'}>
        {infinitePagination.isFetchingNextPage && (
          <LogoSpinner width="50px" isLoading={infinitePagination.isFetchingNextPage} />
        )}
        {!infinitePagination.hasNextPage && <Text fontWeight={700}>You've seen it all</Text>}
      </Center>
    </VStack>
  );
};

export default InfiniteTablePagination;
